import { createAsyncThunk } from '@reduxjs/toolkit';
import { createLead } from '../../api/create-lead';

type CreateLeadThunkRequest = {
    name: string
    phone: string
    comment?: string
}

export const createLeadThunk = createAsyncThunk(
    'createLeadThunk',
    async ({
        name,
        phone,
        comment,
    }: CreateLeadThunkRequest) => createLead(name, phone, comment),
);
